const configuredBackend = process.env.REACT_APP_BACKEND_URL;

export function getBackendUrl() {
  if (!configuredBackend) return window.location.origin;
  try {
    const url = new URL(configuredBackend);
    const localNames = new Set(["localhost", "127.0.0.1"]);
    // A phone cannot resolve the Mac's "localhost". When the configured API
    // is local, retain its port but use the hostname that served the UI.
    if (localNames.has(url.hostname)) {
      url.hostname = window.location.hostname;
    }
    return url.origin;
  } catch {
    return configuredBackend;
  }
}
